import React from "react";
import { Form } from "@ant-design/compatible";
import { Controller } from "react-hook-form";
import { Input, Button, Collapse, AutoComplete } from "antd";
import PropTypes from "prop-types";

const PmsCreateComponent = (props) => {
  const {
    control,
    errors,
    setValue,
    title,
    onSubmit,
    pmsGetData,
    watch,
    clearErrors,
  } = props;

  const dataSource = pmsGetData.map((d) => {
    return { value: d.pms_name };
  });

  const selectOption = (value) => {
    clearErrors(["_id", "pmsName", "pms_name", "pms_version"]);
    const result = pmsGetData?.find(
      (e) => e.pms_name.toUpperCase() === value?.toUpperCase(),
    );
    setValue("pmsName", value);
    if (result) {
      setValue("_id", result._id);
      setValue("pms_name", result.pms_name);
      setValue("pms_version", result.pms_version);
    } else {
      setValue("pms_name", value);
      setValue("pms_version", "");
      setValue("_id", undefined);
    }
  };

  return (
    <>
      <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
        <Collapse.Panel key="2_1" header={title}>
          <Form
            labelCol={{
              xs: { span: 24 },
              sm: { span: 6 },
              md: { span: 6 },
              lg: { span: 5 },
              xl: { span: 5 },
              xxl: { span: 5 },
            }}
            wrapperCol={{
              xs: { span: 24 },
              sm: { span: 18 },
              md: { span: 18 },
              lg: { span: 15 },
              xl: { span: 12 },
              xxl: { span: 12 },
            }}
            onSubmit={onSubmit}
          >
            <Form.Item
              label="PMS Name"
              validateStatus={errors?.pmsName ? "error" : ""}
              help={errors?.pmsName?.message}
              required
            >
              <Controller
                control={control}
                name="pmsName"
                render={({ field: { value, onChange } }) => (
                  <AutoComplete
                    options={dataSource}
                    placeholder="Enter PMS Name"
                    filterOption={(inputValue, option) =>
                      option.value
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onSelect={(e) => {
                      onChange(e);
                      selectOption(e);
                    }}
                    onChange={(e) => {
                      onChange(e);
                      selectOption(e);
                    }}
                    value={value}
                    allowClear
                  />
                )}
              />
            </Form.Item>
            {watch("_id") && (
              <Form.Item
                help={errors?.pms_name?.message}
                label="Rename PMS Name"
                validateStatus={errors?.pms_name ? "error" : ""}
                required
              >
                <Controller
                  control={control}
                  name="pms_name"
                  render={({ field: { onChange, value } }) => (
                    <Input
                      placeholder="Enter Rename PMS name"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Form.Item>
            )}
            <Form.Item label="PMS Version">
              <Controller
                control={control}
                name="pms_version"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Enter PMS Version"
                  />
                )}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
              <Button type="primary" htmlType="submit">
                {!watch("_id") ? "Create" : "Update"}
              </Button>
            </Form.Item>
          </Form>
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

PmsCreateComponent.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  pmsGetData: PropTypes.array.isRequired,
  watch: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

export default PmsCreateComponent;
